import React from 'react';
import { Button } from '@mui/material';
import * as XLSX from 'xlsx';

const ExportExcelButton = ({ data }) => {

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Função para calcular a largura das colunas com base no conteúdo
        const calcColumnWidths = (jsonData) => {
            const columnWidths = [];

            Object.keys(jsonData[0]).forEach(key => {
                const maxLength = jsonData.reduce((max, row) => Math.max(max, String(row[key]).length), key.length);
                columnWidths.push({ wch: maxLength + 2 });
            });

            return columnWidths;
        };

        // Estilo do cabeçalho
        const headerStyle = {
            font: { bold: true, color: { rgb: "FFFFFF" } }, // Fonte branca
            fill: { fgColor: { rgb: "808080" } },  // Cor de fundo cinza
            alignment: { horizontal: "center" },
        };

        // Estilo das bordas
        const borderStyle = {
            top: { style: 'thin', color: { rgb: "000000" } },
            bottom: { style: 'thin', color: { rgb: "000000" } },
            left: { style: 'thin', color: { rgb: "000000" } },
            right: { style: 'thin', color: { rgb: "000000" } }
        };

        // Aplica o estilo ao cabeçalho e bordas
        const headers = Object.keys(data[0]);
        headers.forEach((key, index) => {
            const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
            if (!worksheet[cellAddress]) worksheet[cellAddress] = {};
            worksheet[cellAddress].s = { ...headerStyle, border: borderStyle };  // Aplica estilo de cabeçalho e bordas
        });

        // Aplica bordas a todas as células de dados
        Object.keys(worksheet).forEach((cell) => {
            if (cell[0] !== '!') {  // Ignora células especiais (como !ref)
                worksheet[cell].s = { border: borderStyle };
            }
        });

        // Define a largura automática das colunas
        worksheet['!cols'] = calcColumnWidths(data);

        // Cria o workbook e adiciona a planilha
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Inscritos');

        // Exporta o arquivo XLSX
        XLSX.writeFile(workbook, 'inscritos.xlsx');
    };

    return (
        <button
            onClick={exportToExcel}
            style={{
                backgroundColor: '#107C41', // Verde similar ao Excel
                color: 'white',
                padding: '10px 20px',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
                fontSize: '16px'
            }}>
            Exportar para Excel
        </button>
    );
};

export default ExportExcelButton;
